var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('body'),expression:"'body'"}],ref:"el",staticClass:"btn-to-top",class:{ show: _vm.isShow, footerFix: _vm.isFooter, isCookie: _vm.getCookie }},[_c('div',{staticClass:"icon scroll-top"})])
}
var staticRenderFns = []

export { render, staticRenderFns }